
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { areaSaggioClasseDiametricaStore } from '../store/areaSaggioClasseDiametrica.store';
import { Async } from '@/utils/AsyncDecorators';
import { Guid } from 'guid-typescript';


@Component({})
export default class classeDiametricaCell extends Vue {
  @Prop({required: true})
  versioneId: string;
  
  @Prop({required: true})
  areaSaggio: string;

  @Prop({required: true})
  classeDiametrica: number;

  @Prop({required: true})
  specieArborea: number;

  @Prop({required: true})
  rilevamenti: server.areaSaggioClasseDiametrica[];

  @Prop()
  selected: server.areaSaggioClasseDiametrica;

  get cell() {
    if (this.rilevamenti.length <= 0) return 0;
    let elem = this.rilevamenti.find(f => f.diametro == this.classeDiametrica && f.specie === this.specieArborea);
    if (elem) return elem;
    elem = {
      id: Guid.create().toString(),
      versioneId: this.versioneId,
      areaSaggioId: this.areaSaggio,
      specie: this.specieArborea,
      diametro: this.classeDiametrica,
      contatore: 0
    } as server.areaSaggioClasseDiametrica
    
    areaSaggioClasseDiametricaStore.actions.setAreaSaggioClasseDiametrica(elem);
    return elem;
  }

  public select(cell) {
    this.$emit('select', cell);
  }
}